

export default function open(open_value) {
    if (open_value)
        return true
    return false
}
